import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import {
  nameWithTransactionFormatter,
  statusDateFormatter,
  paymentCellFormatter,
  requestStatusBadge,
  makeEditBadgeFormatter
} from '../utils/tableFormatters';
import { serviceRequestsTypes } from '../helpers/utils';

// Show an Edit badge for supported service types; hide for others.
const getEditRoute = row => {
  switch (row.type) {
    case serviceRequestsTypes.additionalQualification:
      return `/pages/form-additional-qualification/edit/${row.id}`;
    case serviceRequestsTypes.duplicateCertificate:
      return `/pages/form-duplicate-certificate/edit/${row.id}`;
    case serviceRequestsTypes.nameAlteration:
      return `/pages/form-alteration-name/edit/${row.id}`;
    case serviceRequestsTypes.registerInstitution:
      return `/pages/form-registration-institution/edit/${row.id}`;
    case serviceRequestsTypes.certificateGoodStanding:
      return `/pages/form-good-standing/edit/${row.id}`;
    case serviceRequestsTypes.intern2permanent:
      return `/pages/form-intern2permanent/edit/${row.id}`;
    default:
      return null;
  }
};

const actionFormatter = (cell, row) => {
  const to = getEditRoute(row);
  if (!to) return null;
  const editBadge = makeEditBadgeFormatter({
    toBuilder: () => to,
    isDisabled: r => false //String(r.status || '').toUpperCase() === 'APPROVED'
  });
  return editBadge(cell, row);
};

const badgeFormatter = requestStatusBadge;

const memberFormatter = memberName => (
  <Link to={'#'} className="font-weight-semi-bold">
    {memberName}
  </Link>
);

const dateFormatter = date => {
  return date ? <div className="font-weight-semi-bold">{date.substring(0, 10)}</div> : '';
};

// Use shared payment and status/date formatters

export const servicesDashboardColumns = [
  {
    dataField: 'name',
    text: 'Member Name',
    formatter: nameWithTransactionFormatter,
    classes: 'border-0 align-middle',
    headerClasses: 'border-0',
    sort: true
  },
  {
    dataField: 'type',
    text: 'Type',
    classes: 'border-0 align-left',
    headerClasses: 'border-0',
    sort: true
  },
  {
    dataField: 'status',
    text: 'Application Status',
    formatter: statusDateFormatter,
    classes: 'border-0 align-middle',
    headerClasses: 'border-0',
    isDummyField: true,
    sort: true
  },

  {
    dataField: 'payment',
    text: 'Payment',
    formatter: paymentCellFormatter,
    classes: 'border-0 align-right',
    headerClasses: 'border-0',
    isDummyField: true,
    sort: false
  },

  {
    dataField: 'actions',
    text: 'Actions',
    formatter: actionFormatter,
    classes: 'border-0 align-center',
    headerClasses: 'border-0',
    sort: false,
    isDummyField: true
  }
];

export const renewalsDashboardColumns = [
  {
    dataField: 'name',
    text: 'Member Name',
    formatter: memberFormatter,
    classes: 'border-0 align-middle',
    headerClasses: 'border-0',
    sort: true
  },
  {
    dataField: 'transactionId',
    text: 'Transaction #',
    classes: 'border-0 align-middle',
    headerClasses: 'border-0',
    sort: true
  },
  {
    dataField: 'type',
    text: 'Type',
    classes: 'border-0 align-left',
    headerClasses: 'border-0',
    sort: true
  },
  {
    dataField: 'status',
    text: 'Renewal Status',
    formatter: badgeFormatter,
    classes: 'border-0 align-middle fs-0',
    headerClasses: 'border-0',
    sort: true
  },
  {
    dataField: 'applicationDate',
    text: 'Date',
    formatter: dateFormatter,
    classes: 'border-0 align-right',
    headerClasses: 'border-0',
    sort: true
  }
];

export default { renewalsDashboardColumns, memberDashboardColumns: servicesDashboardColumns };
